module.exports = __webpack_public_path__ + "img/sendToClient.2b4f3426.svg";